import { FC, useState } from 'react';
import {
  useStripe,
  useElements,
  PaymentElement,
} from '@stripe/react-stripe-js';
import {
  Grid,
  InputAdornment,
  TextField,
  useTheme,
  FormHelperText,
} from '@mui/material';
import { translateLanguage } from 'components';
import { LoadingButton } from '@mui/lab';
import { OnlineBookingContent } from 'models';
import {
  bookingButtonStyle,
  bookingButtonContainedStyle,
} from 'styles/componentStyle';
import styles from '../index.module.scss';

const CheckoutForm: FC<any> = ({ paymentAmount, handlePaymentResponse }) => {
  const stripe = useStripe();
  const elements = useElements();
  const theme = useTheme();
  const [message, setMessage] = useState<any>(null);
  const [isProcessing, setIsProcessing] = useState<any>(false);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsProcessing(true);
    try {
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: {},
        redirect: 'if_required',
      });
      console.warn('paymentIntent', paymentIntent);
      if (error) {
        handlePaymentResponse(error, false);

        // error.type === 'card_error' || error.type === 'validation_error'
        if (error.type !== null) {
          setMessage(error.message);
        } else {
          setMessage(
            `${translateLanguage(
              `OnlineBooking.${OnlineBookingContent.PAYMENTFAILMSG}`,
            )}`,
          );
        }

        setIsProcessing(false);
      } else {
        switch (paymentIntent.status) {
          case 'succeeded':
            if (paymentIntent.last_payment_error !== null) {
              setMessage(
                `PaymentIntent ${paymentIntent.id} experienced a ${e.type} error.`,
              );
              handlePaymentResponse(paymentIntent, false);
              setIsProcessing(false);
            } else {
              handlePaymentResponse(paymentIntent, true);
              setIsProcessing(false);
            }
            break;
          case 'processing':
            setMessage('Your payment is processing.');
            handlePaymentResponse(paymentIntent, false);
            setIsProcessing(false);
            break;
          case 'requires_payment_method':
            setMessage(
              `${translateLanguage(
                `OnlineBooking.${OnlineBookingContent.PAYMENTFAILMSG}`,
              )}`,
            );
            handlePaymentResponse(paymentIntent, false);
            setIsProcessing(false);
            break;
          default:
            setMessage(
              `${translateLanguage(
                `OnlineBooking.${OnlineBookingContent.PAYMENTFAILMSG}`,
              )}`,
            );
            handlePaymentResponse(paymentIntent, false);
            setIsProcessing(false);
            break;
        }
      }
    } catch (error) {
      // An unexpected error occurred
      handlePaymentResponse(error, false);
      setMessage(
        `${translateLanguage(
          `OnlineBooking.${OnlineBookingContent.PAYMENTFAILMSG}`,
        )}`,
      );
      setIsProcessing(false);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormHelperText error={message}>{message && message}</FormHelperText>
        <TextField
          label={translateLanguage(
            `OnlineBooking.${OnlineBookingContent.PAYAMOUNT}`,
          )}
          value={parseFloat(paymentAmount).toFixed(2)}
          variant="standard"
          sx={{ width: 1, m: theme.spacing(1), ml: 0 }}
          InputProps={{
            startAdornment: (
              <InputAdornment
                position="start"
                className={styles.disabledCurrency}
                sx={{ mr: 0 }}
              />
            ),
            readOnly: true,
          }}
          disabled
        />
      </Grid>
      <Grid item xs={12}>
        <PaymentElement id="payment-element" />
      </Grid>
      <Grid item xs={12}>
        <LoadingButton
          name="payNowBtn"
          variant="contained"
          onClick={handleSubmit}
          sx={{
            m: theme.spacing(1),
            width: 1,
            ...bookingButtonStyle,
            ...bookingButtonContainedStyle,
          }}
          type="button"
          loading={isProcessing}
          id="payNowBtn"
        >
          {translateLanguage(`OnlineBooking.${OnlineBookingContent.PAYNOW}`)}
        </LoadingButton>
      </Grid>
    </Grid>
  );
};

export default CheckoutForm;
